<template>
	<div class="full detail_contaienr">
		<div class="full">
			<el-tabs v-model="activeName" type="border-card">
				<el-tab-pane label="模块" name="module">
					<vxe-table :row-config="{isCurrent: true, isHover: true}" :data="moduleAuthData" size="mini" border height="450" :loading="loading">
						<vxe-column type="seq" width="60"></vxe-column>
						<!-- <vxe-column field="authtype" title="授权类型"></vxe-column> -->
						<vxe-column field="onwer" title="模块名称"></vxe-column>
						<vxe-column field="authname" title="操作名称">
							<template #default="{ row }">
								<span>{{row.authname}}</span>
								<el-tag @click="deleteprivatecontroll(row)" style="margin-left: 10px;cursor: pointer;" effect="dark" type="danger" size="mini" v-if="row.privatecontroll">私</el-tag>
							</template>
						</vxe-column>
						<vxe-column field="authdepartment" title="部门"></vxe-column>
						<vxe-column field="authstaff" title="人员"></vxe-column>
						<vxe-column field="authpostjob" title="岗位"></vxe-column>
						<vxe-column field="authjoblevel" title="职务级别"></vxe-column>
						<vxe-column field="authgroup" title="分组"></vxe-column>
						<vxe-column title="权限" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<vxe-button type="text" status="danger" @click="modulecontrolledit(row,1)">私有</vxe-button>
								<vxe-button type="text" status="success" @click="modulecontrolledit(row)">公有</vxe-button>
							</template>
						</vxe-column>
					</vxe-table>
				</el-tab-pane>
				<el-tab-pane label="报表" name="report">
					<vxe-table :row-config="{isCurrent: true, isHover: true}" :data="reportAuthData" size="mini" border height="450" :loading="loading">
						<vxe-column type="seq" width="60"></vxe-column>
						<!-- <vxe-column field="authtype" title="授权类型"></vxe-column> -->
						<vxe-column field="onwer" title="报表名称"></vxe-column>
						<vxe-column field="authname" title="操作名称">
<!-- 							<template #default="{ row }">
								<el-link style="font-size:12px;" type="primary" @click="reportcontrolledit(row)">
									{{row.authname}}
								</el-link>
							</template> -->
						</vxe-column>
						<vxe-column field="authdepartment" title="部门"></vxe-column>
						<vxe-column field="authstaff" title="人员"></vxe-column>
						<vxe-column field="authpostjob" title="岗位"></vxe-column>
						<vxe-column field="authjoblevel" title="职务级别"></vxe-column>
						<vxe-column field="authgroup" title="分组"></vxe-column>
						<vxe-column title="权限" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<!-- <vxe-button type="text" status="danger" @click="modulecontrolledit(row)">私有</vxe-button> -->
								<vxe-button type="text" status="success" @click="reportcontrolledit(row)">公有</vxe-button>
							</template>
						</vxe-column>
<!-- 						<vxe-column title="操作" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<vxe-button type="text" status="success" @click="authedit(row)">编辑授权</vxe-button>
							</template>
						</vxe-column> -->
					</vxe-table>
				</el-tab-pane>
				<el-tab-pane label="表单" name="form">
					<vxe-table :row-config="{isCurrent: true, isHover: true}" :data="formAuthData" size="mini" border height="450" :loading="loading">
						<vxe-column type="seq" width="60"></vxe-column>
						<!-- <vxe-column field="authtype" title="授权类型"></vxe-column> -->
						<vxe-column field="onwer" title="表单名称"></vxe-column>
						<vxe-column field="authname" title="操作名称">
<!-- 							<template #default="{ row }">
								<el-link style="font-size:12px;" type="primary" @click="formcontrolledit(row)">
									{{row.authname}}
								</el-link>
								<vxe-button type="text" icon="el-icon-search" size="mini" @click="formpreview(row)">
								</vxe-button>
							</template> -->
						</vxe-column>
						<vxe-column field="authdepartment" title="部门"></vxe-column>
						<vxe-column field="authstaff" title="人员"></vxe-column>
						<vxe-column field="authpostjob" title="岗位"></vxe-column>
						<vxe-column field="authjoblevel" title="职务级别"></vxe-column>
						<vxe-column field="authgroup" title="分组"></vxe-column>
						<vxe-column title="权限" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<!-- <vxe-button type="text" status="danger" @click="modulecontrolledit(row)">私有</vxe-button> -->
								<vxe-button type="text" status="success" @click="formcontrolledit(row)">公有</vxe-button>
							</template>
						</vxe-column>
<!-- 						<vxe-column title="操作" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<vxe-button type="text" status="success" @click="authedit(row)">编辑授权</vxe-button>
							</template>
						</vxe-column> -->
					</vxe-table>
				</el-tab-pane>
				<el-tab-pane label="流程" name="flow">
					<vxe-table :row-config="{isCurrent: true, isHover: true}" :data="flowAuthData" size="mini" border height="450" :loading="loading">
						<vxe-column type="seq" width="60"></vxe-column>
						<!-- <vxe-column field="authtype" title="授权类型"></vxe-column> -->
						<vxe-column field="onwer" title="所属表单"></vxe-column>
<!-- 						<vxe-column field="authname" title="流程名称">
							<template #default="{ row }">
								<el-link style="font-size:12px;" type="primary" @click="flowedit(row)">
									{{row.authname}}
								</el-link>
							</template>
						</vxe-column> -->
						<vxe-column field="authdepartment" title="部门"></vxe-column>
						<vxe-column field="authstaff" title="人员"></vxe-column>
						<vxe-column field="authpostjob" title="岗位"></vxe-column>
						<vxe-column field="authjoblevel" title="职务级别"></vxe-column>
						<vxe-column field="authgroup" title="分组"></vxe-column>
						<vxe-column title="权限" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<!-- <vxe-button type="text" status="danger" @click="modulecontrolledit(row)">私有</vxe-button> -->
								<vxe-button type="text" status="success" @click="flowedit(row)">公有</vxe-button>
							</template>
						</vxe-column>
<!-- 						<vxe-column title="操作" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<vxe-button type="text" status="success" @click="authedit(row)">编辑授权</vxe-button>
							</template>
						</vxe-column> -->
					</vxe-table>
				</el-tab-pane>
			</el-tabs>
		</div>
		<component :is="formModule.component" v-if="formModule.show" :name="formModule.name" :id="formModule.id"
			:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
			@back="formBack" />
	</div>


</template>
<style scoped>
	.detail_contaienr {
		box-sizing: border-box;
		padding: 10px;
	}
</style>
<script>
	export default {
		name: '',
		props: {
			staffid: {
				type: Number,
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				loading:true,
				activeName: 'module',
				moduleAuthData: [],
				reportAuthData:[],
				formAuthData: [],
				flowAuthData: [],
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				},
			}
		},
		watch: {

		},
		created() {
			this.list()
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			list() {
				this.$api.auth.getTotalAuth({
					staffid: this.staffid,
					type:'staff'
				}).then((res) => {
					this.moduleAuthData = this.initlist(res.module)
					this.reportAuthData = this.initlist(res.report)
					this.formAuthData = this.initlist(res.form)
					this.flowAuthData = this.initlist(res.flow)
					this.loading = false
				})
			},
			initlist(list) {
				list.forEach((item) => {
					let authFrom = []
					item.authfrom.forEach((_item) => {
						if (_item.type == 'department') {
							if (!item['authdepartment']) {
								authFrom['authdepartment'] = []
							}
							authFrom['authdepartment'].push(window.systemMethods.getdepartment(_item.id) +
								(
									_item.typename ? '(' + _item.typename + ')' : ''))
						}
						if (_item.type == 'staff') {
							if (!authFrom['authstaff']) {
								authFrom['authstaff'] = []
							}
							authFrom['authstaff'].push(window.systemMethods.getstaff(_item.id))
						}
						if (_item.type == 'postjob') {
							if (!authFrom['authpostjob']) {
								authFrom['authpostjob'] = []
							}
							authFrom['authpostjob'].push(window.systemMethods.getpostjob(_item.id))
						}
						if (_item.type == 'joblevel') {
							if (!authFrom['authjoblevel']) {
								authFrom['authjoblevel'] = []
							}
							authFrom['authjoblevel'].push(window.systemMethods.getjoblevel(_item.id))
						}
						if (_item.type == 'group') {
							if (!authFrom['authgroup']) {
								authFrom['authgroup'] = []
							}
							authFrom['authgroup'].push(window.systemMethods.getgroup(_item.id))
						}
					})
					for (let i in authFrom) {
						item[i] = authFrom[i].join('，')
					}
				})
				return list
			},
			deleteprivatecontroll(row){
				this.$confirm('是否删除私有权限').then(()=>{
					this.$api.auth.deleteprivatecontroll({
						id:row.privatecontroll,
					}).then(()=>{
						row.privatecontroll = 0
					})
				})
				
			},
			modulecontrolledit(row,isprivate=0) {
				this.$api.module.get(row.onwerid).then((e) => {
					let title = '【公有】模块操作 / ' + row.onwer + ' / ' + row.authname + ''
					if(isprivate==1){
						title = '【私有】模块操作 / ' + row.onwer + ' / ' + row.authname + ''
					}
					import('@_system/components/forms/moudel/controll/form.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: 'modulecontroll',
							id: row.controllId,
							controlltype: 2,
							show: true,
							foreingKey: {
								moduleid: row.onwerid,
							},
							extra: {
								title: title,
								toolbarbutton: e.toolbarbutton,
								operatebutton: e.operatebutton,
								listfield: e.listfield.listfield,
								isprivate:isprivate,
								staffid:this.staffid
							}
						}
					})
				})
			},
			reportcontrolledit(row){
				this.$api.report.get(row.onwerid).then((e) => {
					import('@_system/components/forms/report/controll/form.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: 'reportcontroll',
							id: row.controllId,
							controlltype: 2,
							show: true,
							foreingKey: {
								reportid: row.onwerid,
							},
							extra: {
								title: '报表操作 / ' + row.onwer + ' / ' + row.authname + '',
								toolbarbutton: e.toolbarbutton,
								operatebutton: e.operatebutton,
								listfield: e.listfield.listfield
							}
						}
					})
				})
			},
			formcontrolledit(row) {
				this.$api.form.get(row.onwerid).then((e) => {
					import('@_system/components/forms/form/controll/form.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: 'formcontroll',
							id: row.controllId,
							controlltype: 2,
							show: true,
							foreingKey: {
								formid: row.onwerid
							},
							extra: {
								title: '表单操作 / ' + row.onwer + ' / ' + row.authname + '',
								targetRule: e.rule
							}
						}
					})
				})
			},
			formpreview(row) {
				this.$api.form.get(row.onwerid).then((e) => {
					import('@_system/components/forms/form/preview.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: '',
							show: true,
							extra: {
								rule: e.rule,
								title: e.title,
								controll: JSON.parse(row.controll),
								controllname: row.authname
							}
						}
					})
				})

			},
			flowedit(row) {
				import('@_system/components/forms/form/flow/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'flow',
						id: row.controllId,
						show: true,
						foreingKey: {
							formid: row.onwerid
						},
						extra: {
							title: '流程 / ' + row.onwer + ' / ' + row.authname + '',
						},
						controlltype: 1,
					}
				})
			},
			authedit(row) {
				import('@_system/components/forms/auth/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'auth',
						id: row.controllId,
						show: true,
						extra: {
							title: row.authtype + '授权 / ' + row.onwer + ' / ' + row.authname + '',
							type: row.type,
						}
					}
				})
			},
			formBack() {
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				this.customreload()
			},
			customreload() {
				this.list()
			}
		},
		components: {

		}
	}
</script>
